import { render, staticRenderFns } from "./sql-backup.vue?vue&type=template&id=3c2a7252&scoped=true&"
import script from "./sql-backup.vue?vue&type=script&lang=js&"
export * from "./sql-backup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c2a7252",
  null
  
)

export default component.exports